import script from "./PricePart.vue?vue&type=script&setup=true&lang=js"
export * from "./PricePart.vue?vue&type=script&setup=true&lang=js"

import "./PricePart.vue?vue&type=style&index=0&id=6562d75c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6562d75c"]])

export default __exports__